<template>
  <div class="card">
    <!-- Roles Form Modal -->
    <modal :show.sync="roleForm.modal" size="lg" class="col-12">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Cadastrar Grupos</h5>
      </template>
      <validation-observer v-slot="{handleSubmit}" ref="formValidator">
        <form role="form" @submit.prevent="handleSubmit(save)">
          <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
            <base-input
              group
              :required="true"
              class="mb-3"
              v-model="roleForm.role.name"
              label="Nome do Grupo"
              placeholder="Nome do Grupo"
              success-message="Campo preenchido"
              :error="errors[0]"
            />
          </ValidationProvider>
          <base-input>
            <el-select
              v-model="roleForm.role.default_to"
              filterable
              placeholder="Este é um grupo padrão para algum tipo de usuário?"
              id="ControlSelect1"
            >
              <el-option label="Gerente Comercial" value="manager"></el-option>
              <el-option label="Vendedor" value="salesman"></el-option>
            </el-select>
          </base-input>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button type="secondary" @click="roleForm.modal = false">Fechar</base-button>
        <base-button type="success" @click="saveRole">Savar</base-button>
      </template>
    </modal>
    <!-- Card tabs -->
    <div class="card-tabs">
      <ul class="nav nav-tabs" id="permissionableTabs" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{active: permissionableType == 'group'}"
            @click="setPermissionable('group')"
          >Grupos</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{active: permissionableType == 'user'}"
            @click="setPermissionable('user')"
          >Usuários</a>
        </li>
      </ul>
    </div>
    <!-- Card content -->
    <div class="card-body">
      <!-- Search form -->
      <div class="row form-group" style>
        <div class="col-sm-12 col-md-10 mb-0">
          <base-input
            wrapperClass
            prepend-icon="fas fa-search"
            :hasIcon="false"
            :placeholder="'Pesquisar '+ permissionableName()"
            v-model="q.name"
            @input="debouncedGetData"
            type="search"
          ></base-input>
        </div>
        <base-button class="mb-0" type="success" @click="addRole()">
          <i class="fa fa-plus"></i>
        </base-button>
      </div>

      <dynamic-list
        :actions="permissionableType == 'group'"
        :list="permissionables"
        itemName="name"
        itemKey="id"
        v-model="selectedItem"
        @item-selected="itemSelected($event)"
      >
        <template v-if="permissionableType == 'group'" v-slot:actions="{ item }">
          <a class="dropdown-item" href="#" @click="editRole(item)">Editar</a>
          <a class="dropdown-item" href="#" @click="deleteRole(item)">Excluir</a>
        </template>
      </dynamic-list>
    </div>
    <!-- Paginator -->
    <div class="card-footer py-4 d-flex justify-content-end">
      <base-pagination
        v-on:input="changePage"
        v-model="paginated_data.current"
        :total="paginated_data.count"
        :perPage="paginated_data.per_page"
      ></base-pagination>
    </div>
  </div>
</template>

<script>
  import { Select, Option } from "element-ui";
  import { ValidationProvider, extend } from "vee-validate";
  import DynamicList from "@/components/DynamicList/DynamicList";
  import { required } from "vee-validate/dist/rules";
  extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

  export default {
    name: "permissionables-card",
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      DynamicList,
      ValidationProvider,
    },
    model: {
      prop: "selectedItem",
      event: "change",
    },
    props: {
      selectedItem: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        permissionableType: "group",
        permissionables: [],
        paginated_data: {},
        q: { name: null },
        roleForm: {
          modal: false,
          role: {},
        },
        getDataTimeout: null,
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      debouncedGetData() {
        if (this.getDataTimeout) clearTimeout(this.getDataTimeout);

        this.getDataTimeout = setTimeout(
          () => this.getData(),
          700
        );
      },
      getData(page) {
        if (typeof page === "undefined") page = null;

        let path = "/api/v1/";
        if (this.permissionableType == "group") path += "roles";
        if (this.permissionableType == "user") path += "users";
        this.$http.secured
          .get(path, { params: { page: page, q: this.query } })
          .then((response) => {
            this.paginated_data = response.data;
            if (this.permissionableType == "group")
              this.permissionables = this.paginated_data["roles"];
            if (this.permissionableType == "user")
              this.permissionables = this.paginated_data["users"];
          });
      },
      itemSelected(event) {
        event.permissionableType = this.permissionableType;
        this.$emit("item-selected", event, this.permissionableType);
      },
      addRole() {
        this.roleForm.role = {};
        this.roleForm.modal = true;
      },
      editRole(role) {
        console.log("role:", role);
        this.roleForm.role = role;
        this.roleForm.modal = true;
      },
      saveRole() {
        if (this.roleForm.role.id) {
          this.$http.secured
            .put("/api/v1/roles/" + this.roleForm.role.id, {
              role: this.roleForm.role,
            })
            .then((response) => {
              this.$toasted.global.defaultSuccess();
              this.roleForm.modal = false;
            });
        } else {
          this.$http.secured
            .post("/api/v1/roles", { role: this.roleForm.role })
            .then((response) => {
              this.permissionables.push(response.data);
              this.$toasted.global.defaultSuccess();
              this.roleForm.modal = false;
            });
        }
      },
      deleteRole(role) {
        if (confirm("Deseja realmente excluir o papel " + `${role.name}` + "?")) {
          this.$http.secured
            .delete(`/api/v1/roles/${role.id}`, role)
            .then((response) => {
              this.$toasted.global.defaultSuccess();
              this.permissionables.splice(this.permissionables.indexOf(role), 1);
            });
        }
      },
      changePage(page) {
        this.getData(page);
      },
      setPermissionable(permissionable) {
        this.permissionableType = permissionable;
        this.getData();
      },
      permissionableName() {
        if (this.permissionableType == "group") return "Grupo";
        if (this.permissionableType == "user") return "Usuário";
        return "";
      },
    },
    computed: {
      query: function() {
        let filter = this.q;
        for(let key in filter){
          // removing empty fields
          if (filter[key] == "" || filter[key] == null ) {
            delete filter[key];
          }
        }

        if(Object.keys(filter).length) {
          return filter
        } else {
          return null;
        }
      }
    }
  };
</script>
